module.exports = __webpack_public_path__ + "img/a04-1.faa5092f.png";